import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
/* import mylogo from "../assets/images/mylogo.png"; */
import authsService from "../services/auths.service";
import mylogo from "../assets/images/letscoolfulllogowhite.png";

const Home = () => {
  const userinfo = authsService.userinfo();

  let navigate = useNavigate();

  return (
    <div style={{ position: "absolute", minHeight: "100%" }} className="bg-primary p-5">
      <div className=" ">
        <div className="row p-0 m-0">
          <div className="col-md-7 text-white">
            <p>
              <img
                className=""
                style={{ width: 80, height: 100 }}
                src={mylogo}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = { mylogo };
                }}
                alt="letscool"
              /></p>
            <h1 style={{fontSize:40,color:"white"}}>Welcome<br></br>Back</h1>
            <p>
              Air conditioning preventive maintenance developed by letscool. This application can streamline the process of maintaining AC units in both residential and commercial
            </p>

          </div>
          <div className="col-md-5">
            <div style={{ border: "1px solid white", borderRadius: 20 }} className="p-5 mt-5 bg-white">
              <h2>Login to your Account</h2>
              <p>
                Kindly choose your specific login role by selecting one of the following options: Technician,Admin, or Client to access your respective account and functionalities.              </p>
              <a onClick={() => navigate("/signinc")} className="btn btn-outline btn-lg btn-primary d-block mb-2">Client {/* <i className="fa fa-chevron-right"></i> */}</a>
              <a onClick={() => navigate("/signint")} className="btn btn-outline btn-lg btn-primary d-block mb-2">Technician {/* <i className="fa fa-chevron-right"></i> */}</a>
              <a onClick={() => navigate("/signin")} className="btn btn-outline btn-lg btn-primary d-block">Admin {/* <i className="fa fa-chevron-right"></i> */}</a>
            </div>
          </div>
        </div>
      </div>
      {/*  <div className=" ">
        <div className="row  p-5">
          <div className="col-md-6">
            <img
              className=""
              style={{ width: 80, height: 100 }}
              src={mylogo}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = { mylogo };
              }}
              alt="letscool"
            />
            <h1>Welcome<br></br>Back</h1>
            <p>
              Air conditioner preventive maintenance is a proactive
              approach to keeping your AC system in good working condition. It involves regular check-ups, cleaning, and servicing to prevent issues and ensure efficient cooling
            </p>

          </div>
          <div className="col-md-6">
            <div style={{border:"1px solid white",paddingTop:30}} className="p-3">
              <p>
                Choosing the right login method depends on your role and access requirements.
              </p>
              <a onClick={() => navigate("/signinc")} className="btn btn-lg btn-light d-block mb-2">Continue with Client</a>
              <a onClick={() => navigate("/signint")} className="btn btn-lg btn-light d-block mb-2">Continue with Technition</a>
              <a onClick={() => navigate("/signin")} className="btn btn-lg btn-dark d-block">Continue with Admin</a>
            </div>
          </div>

        </div>
      </div>

      <div className="d-flex flex-column justify-content-center h-100 d-none">
        <div className="d-flex flex-fill justify-content-center p-3 pt-5">
          <img
            className=""
            style={{ width: 120, height: 150 }}
            src={mylogo}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = { mylogo };
            }}
            alt="letscool"
          />
        </div>
        <div>
          <div className="p-3 pb-5 w-md-50">
            <a onClick={() => navigate("/signinc")} className="btn btn-lg btn-light d-block mb-2">Continue with Client</a>
            <a onClick={() => navigate("/signint")} className="btn btn-lg btn-light d-block mb-2">Continue with Technition</a>
            <a onClick={() => navigate("/signin")} className="btn btn-lg btn-dark d-block">Continue with Admin</a>
          </div>
          <div className="row d-none">
            <div className="col-md-6">
              <div className="m-3 p-3 shadow-sm bg-white m-2 rounded">
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  Employee Login
                </div>
                <div>
                  Click to sign in and keep connect with us, if you are having
                  the EMPLOYEE account on letscoolsupport.
                </div>
                <a
                  onClick={() => navigate("/signina")}
                  className="btn btn-primary mt-3"
                >
                  Go to login
                </a>
              </div>
            </div>
            <div className="col-md-6">
              <div className="m-3 p-3 shadow-sm bg-white m-2 rounded">
                <div style={{ fontSize: 20, fontWeight: 600 }}>Admin Login</div>
                <div>
                  Click to sign in and keep connect with us, if you are having
                  the ADMIN account on letscoolsupport.
                </div>
                <a
                  onClick={() => navigate("/signin")}
                  className="btn btn-primary mt-3"
                >
                  Go to login
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Home;
